import { render, staticRenderFns } from "./TbodyCompliance.vue?vue&type=template&id=b731e8aa"
import script from "./TbodyCompliance.vue?vue&type=script&lang=js"
export * from "./TbodyCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports